import { defineStore } from 'pinia'
import { storeUtils } from '../utils/store.js'

export const useBagInventoryStore = defineStore({
  id: 'bagInventory',
  state: () => ({
    // discounts: [], //avoid using global state if at all possible
  }),
  actions: {
    
    async searchBagInventory(page, pageSize, sortBy, sortDirection, searchQuery) {
      const BagInventory = await storeUtils.search('BagInventory', page, pageSize, sortBy, sortDirection, searchQuery)
      return BagInventory
    },

    async searchBagInventoryWhatsInStock(page, pageSize, sortBy, sortDirection, searchQuery) {
      const BagInventory = await storeUtils.search('BagInventory/GetWhatIsInStockPaged', page, pageSize, sortBy, sortDirection, searchQuery)
      return BagInventory
    },

    async fetchUploadedBagInventory() {
      const UploadedBagInventory = await storeUtils.fetchOne('BagInventory/GetUploadedBags')
      return UploadedBagInventory;
    },

    async fetchBagInventory(id) {
      const BagInventory = await storeUtils.fetchOne('BagInventory/', id)
      return BagInventory;
    },

    async createBagInventory(bagInventory) {
      const BagInventory = await storeUtils.create(`BagInventory`, bagInventory)
      return BagInventory;
    },
    
 
    async updateBagInventory(bagInventory) {
      const BagInventory = await storeUtils.update(`BagInventory`, bagInventory)
      return BagInventory;
    },

    async assignEmployeeBagInventory(data) {
      const BagInventory = await storeUtils.update(`BagInventory/AssignEmployee`, data)
      return BagInventory;
    },

    async assignBx2EmployeeBagInventory(data) {
      const BagInventory = await storeUtils.update(`BagInventory/AssignBx2Employee`, data)
      return BagInventory;
    },
    
    async deleteBagInventory(id) {
      const BagInventory = await storeUtils.delete('BagInventory', id)
      return BagInventory;
    },

    async returnBagsToSupplier(ids) {
      const response = await storeUtils.create('BagInventory/ReturnBagsToSupplier', ids);
      return response;
    },

    async getBagsByIds(ids) {
      const params = ids.map(id => `ids=${id}`).join('&');
      const response = await storeUtils.fetch(`BagInventory/GetByIds?${params}`);
      return response;
    },

    async fetchReturnedToSupplier(page, pageSize, sortBy, sortDirection, searchQuery) {
      let params = `page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&sortDirection=${sortDirection}`;
      if (searchQuery) params += `&searchQuery=${encodeURIComponent(searchQuery)}`;
      const response = await storeUtils.fetch(`BagInventory/GetReturnedToSupplier?${params}`);
      if (response && response.ok) return await response.json();
      return null;
    },

  },
})